import { render, staticRenderFns } from "./SelectUploadFormat.vue?vue&type=template&id=a8f43f28"
import script from "./SelectUploadFormat.vue?vue&type=script&lang=js"
export * from "./SelectUploadFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports